// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"fe35fa88","213":"fe35fa88","652":"fe35fa88","900":"fe35fa88","902":"fe35fa88"}[chunkId] + ".chunk.css";
};